import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const NewsContext = createContext();

export const NewsProvider = ({ children }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  const parseDotNetDate = (dotNetDate) => {
    if (!dotNetDate) return new Date();
    const timestamp = parseInt(dotNetDate.replace(/[^0-9]/g, ""));
    return new Date(timestamp);
  };

  const formatDate = (dotNetDate) => {
    const date = parseDotNetDate(dotNetDate);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  // Fetch all news
  const fetchNews = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/news`
      );

      if (Array.isArray(res.data?.data)) {
        const sorted = res.data.data.sort((a, b) => {
          const dateA = parseDotNetDate(a.Date || a.Created_Date);
          const dateB = parseDotNetDate(b.Date || b.Created_Date);
          return dateB - dateA;
        });

        const formatted = sorted.map(item => ({
          ...item,
          formattedTitle: item.Tittle,
          formattedDate: formatDate(item.Date || item.Created_Date),
          link: `/news/${item.Id}`
        }));

        setNews(formatted);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch news on component mount
  useEffect(() => {
    fetchNews();
  }, []);

  return (
    <NewsContext.Provider value={{ news, loading, fetchNews }}>
      {children}
    </NewsContext.Provider>
  );
};

export const useNews = () => useContext(NewsContext);
